module.exports = __webpack_public_path__ + "img/vietnam.5939e42f.svg";